import { Box, Tab, Tabs, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import AIEmailGenerator from './AIEmailGenerator/AIEmailGenerator';
import diggBackground from '../../assets/Images/backgroundImage.svg';
import diggBackgroundLight from '../../assets/Images/backgroundImageLight.svg';

const EmailGeneration = () => {
	const theme = useTheme();
	const isLightMode = theme.palette.mode === 'light';
	const [tabValue, setTabValue] = useState(0);

	useEffect(() => {
		const rootEl = document.getElementById('app-root');
		if (!rootEl) return;

		rootEl.style.backgroundImage = 'none';

		return () => {
			rootEl.style.backgroundImage = `url(${
				theme.palette.mode === 'dark' ? diggBackground : diggBackgroundLight
			})`;
		};
	}, [theme.palette.mode]);

	return (
		<div className='Advertisement_channel_effect' style={{ width: '100%' }}>
			<Box mt={1}>
				<Tabs
					value={tabValue}
					onChange={(e, newValue) => setTabValue(newValue)}
					variant='standard'
					textColor='inherit'
					sx={{
						ml: 2,
						'.MuiTabs-flexContainer': {
							gap: '12px',
						},
						'& .MuiTabs-indicator': {
							display: 'none',
						},
					}}
				>
					<Tab
						label='AI Email Generator'
						sx={{
							position: 'relative',
							zIndex: 1,
							borderRadius: '20px',
							minHeight: 'unset',
							minWidth: '130px',
							textTransform: 'capitalize',
							fontWeight: 'bold',
							color: theme.palette.text.primary,
							border: '2px solid #777',
							backgroundColor: isLightMode ? '#fff' : '#121212',
							'&.MuiButtonBase-root': {
								padding: '14px 31px',
								fontSize: '16px',
							},
							'&.Mui-selected': {
								border: '2px solid transparent',
								backgroundOrigin: 'border-box',
								backgroundClip: 'padding-box, border-box',
								backgroundImage: isLightMode
									? 'linear-gradient(#fff, #fff), linear-gradient(90deg, #9149ff, #e600ff)'
									: 'linear-gradient(#121212, #121212), linear-gradient(90deg, #9149ff, #e600ff)',
							},
							'&:hover': {
								opacity: 0.9,
							},
						}}
					/>
				</Tabs>

				<Box sx={{ display: tabValue === 0 ? 'block' : 'none', p: 2 }}>
					<AIEmailGenerator />
				</Box>
			</Box>
		</div>
	);
};

export default EmailGeneration;
